import * as Yup from 'yup';


const addSessionNoteSchema = Yup.object().shape({
  note: Yup.string().required('Note is required.'),
});

export default addSessionNoteSchema;
